<div class="w-full min-h-screen bg-[#232323] text-white">
    <div class="px-6 md:px-16 py-8">
        <!-- Header -->
        <header class="mb-8">
            <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
                <div class="flex items-center gap-4">
                    <div class="p-3 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl shadow-lg shadow-amber-500/20">
                        <mat-icon class="material-symbols-outlined text-white icon-size-8">leaderboard</mat-icon>
                    </div>
                    <div>
                        <h1 class="text-3xl md:text-4xl font-extrabold text-white">Ranking</h1>
                        @if (selectedImobiliariaName) {
                            <p class="text-white/60 text-base md:text-lg font-medium mt-1">{{ selectedImobiliariaName }}</p>
                        } @else {
                            <p class="text-white/50 text-sm mt-1">Classificação por pontuação</p>
                        }
                    </div>
                </div>
                
                <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full lg:w-auto">
                    <!-- Autocomplete de Imobiliária (para ADM_SISTEMA e PARCEIRO) -->
                    @if (needsImobiliariaSelection) {
                        <mat-form-field appearance="outline" class="fuse-mat-dense fuse-mat-rounded w-full sm:w-80">
                            <mat-label class="text-white">Selecione a Imobiliária</mat-label>
                            <input matInput 
                                   [formControl]="imobiliariaCtrl" 
                                   [matAutocomplete]="autoImobiliaria" 
                                   (input)="filterImobiliarias($event)" 
                                   placeholder="Digite para buscar..." 
                                   class="text-white placeholder:text-white/40">
                            <mat-autocomplete #autoImobiliaria="matAutocomplete" 
                                              [displayWith]="displayImobiliariaFn" 
                                              (optionSelected)="onImobiliariaSelected($event.option.value)">
                                @for (imob of filteredImobiliarias; track imob.id) {
                                    <mat-option [value]="imob">{{ imob.nome }}</mat-option>
                                }
                            </mat-autocomplete>
                            <mat-icon matSuffix svgIcon="heroicons_outline:building-office-2" class="icon-size-5 text-white/60"></mat-icon>
                        </mat-form-field>
                    }
                    
                    <!-- Posição do usuário -->
                    @if (data()?.currentUserPosicao; as pos) {
                        <div class="flex items-center gap-3 bg-gradient-to-r from-amber-500/20 to-orange-500/10 px-5 py-3 rounded-xl border border-amber-500/30 backdrop-blur-sm">
                            <div class="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center">
                                <mat-icon svgIcon="heroicons_solid:user" class="text-white icon-size-5"></mat-icon>
                            </div>
                            <div>
                                <span class="text-white/60 text-xs uppercase tracking-wider font-medium">Sua posição</span>
                                <div class="font-black text-amber-500 text-2xl leading-none">#{{ pos }}</div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </header>

        <!-- Estado inicial - precisa selecionar imobiliária -->
        @if (needsImobiliariaSelection && !currentImobiliariaId) {
            <div class="bg-gradient-to-br from-zinc-900 to-zinc-900/80 rounded-2xl p-12 border border-zinc-800 text-center">
                <div class="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-amber-500/20 to-orange-500/10 rounded-full flex items-center justify-center">
                    <mat-icon class="material-symbols-outlined text-amber-500 icon-size-12">leaderboard</mat-icon>
                </div>
                <h2 class="text-2xl font-bold text-white mb-3">Selecione uma Imobiliária</h2>
                <p class="text-white/50 max-w-md mx-auto text-base leading-relaxed">
                    Para visualizar o ranking de pontuação dos colaboradores, selecione uma imobiliária no campo acima.
                </p>
            </div>
        }

        <!-- Loading Skeleton -->
        @if (loading()) {
            <div class="space-y-6">
                <!-- Skeleton do pódio -->
                <div class="bg-zinc-900 rounded-2xl p-8 pt-20 border border-zinc-800 animate-pulse">
                    <div class="flex items-end justify-center gap-8 md:gap-12">
                        <div class="flex flex-col items-center">
                            <div class="w-24 h-24 md:w-28 md:h-28 rounded-full bg-zinc-700/50"></div>
                            <div class="h-4 bg-zinc-700/50 rounded-full w-20 mt-4"></div>
                            <div class="h-6 bg-zinc-700/50 rounded-full w-16 mt-2"></div>
                        </div>
                        <div class="flex flex-col items-center -mt-8">
                            <div class="w-32 h-32 md:w-40 md:h-40 rounded-full bg-zinc-700/50"></div>
                            <div class="h-5 bg-zinc-700/50 rounded-full w-28 mt-4"></div>
                            <div class="h-8 bg-zinc-700/50 rounded-full w-20 mt-2"></div>
                        </div>
                        <div class="flex flex-col items-center">
                            <div class="w-24 h-24 md:w-28 md:h-28 rounded-full bg-zinc-700/50"></div>
                            <div class="h-4 bg-zinc-700/50 rounded-full w-20 mt-4"></div>
                            <div class="h-6 bg-zinc-700/50 rounded-full w-16 mt-2"></div>
                        </div>
                    </div>
                </div>
                <!-- Skeleton da lista -->
                <div class="bg-zinc-900 rounded-2xl p-6 border border-zinc-800">
                    @for (item of [1,2,3,4,5]; track item) {
                        <div class="flex items-center gap-4 py-5 border-b border-zinc-800/50 last:border-0 animate-pulse">
                            <div class="w-10 h-10 rounded-full bg-zinc-700/50"></div>
                            <div class="w-14 h-14 rounded-full bg-zinc-700/50"></div>
                            <div class="flex-1 space-y-2">
                                <div class="h-4 bg-zinc-700/50 rounded-full w-1/3"></div>
                                <div class="h-3 bg-zinc-700/50 rounded-full w-1/5"></div>
                            </div>
                            <div class="h-7 bg-zinc-700/50 rounded-full w-20"></div>
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Error -->
        @if (!loading() && error()) {
            <div class="bg-red-500/10 border border-red-500/30 rounded-2xl p-6">
                <div class="flex items-center gap-4">
                    <div class="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                        <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-400 icon-size-6"></mat-icon>
                    </div>
                    <div>
                        <h3 class="font-semibold text-red-400">Erro ao carregar ranking</h3>
                        <p class="text-red-400/70 text-sm">{{ error() }}</p>
                    </div>
                </div>
            </div>
        }

        <!-- Conteúdo do Ranking -->
        @if (!loading() && data(); as d) {
            @if (d.itens.length === 0) {
                <!-- Sem dados -->
                <div class="bg-gradient-to-br from-zinc-900 to-zinc-900/80 rounded-2xl p-12 border border-zinc-800 text-center">
                    <div class="w-24 h-24 mx-auto mb-6 bg-amber-500/10 rounded-full flex items-center justify-center">
                        <mat-icon class="material-symbols-outlined text-amber-500/50 icon-size-12">emoji_events</mat-icon>
                    </div>
                    <h2 class="text-2xl font-bold text-white mb-3">Ranking ainda não disponível</h2>
                    <p class="text-white/50 text-base max-w-lg mx-auto leading-relaxed">
                        Esta imobiliária ainda não possui colaboradores com pontos no ranking. 
                        Os pontos são acumulados conforme os colaboradores completam atividades na plataforma.
                    </p>
                </div>
            } @else {
                <!-- Pódio Top 3 -->
                @if (top3.length >= 1) {
                    <section class="relative bg-gradient-to-b from-zinc-800/80 to-zinc-900 rounded-2xl p-8 border border-zinc-700/50 mb-6">
                        <!-- Background decorativo -->
                        <div class="absolute inset-0 opacity-30 pointer-events-none overflow-hidden rounded-2xl">
                            <div class="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-amber-500/20 rounded-full blur-3xl"></div>
                        </div>
                        
                        <!-- Título do pódio -->
                        <div class="relative flex items-center justify-center mb-14">
                            <div class="flex items-center gap-2 bg-zinc-800/90 backdrop-blur-sm px-4 py-1.5 rounded-full border border-zinc-700/50">
                                <mat-icon class="material-symbols-outlined text-amber-500 text-sm">emoji_events</mat-icon>
                                <span class="text-white/70 text-xs font-semibold uppercase tracking-wider">Top 3</span>
                            </div>
                        </div>
                        
                        <div class="relative flex items-end justify-center gap-4 md:gap-10 lg:gap-16 pt-8">
                            <!-- 2º Lugar -->
                            @if (top3.length >= 2) {
                                <div class="flex flex-col items-center transform hover:scale-105 transition-transform duration-300">
                                    <div class="relative mb-3">
                                        <!-- Badge de posição -->
                                        <div class="absolute -top-3 left-1/2 -translate-x-1/2 z-10 w-8 h-8 bg-gradient-to-br from-gray-300 to-gray-500 rounded-full flex items-center justify-center font-black text-lg text-zinc-900 shadow-lg ring-4 ring-zinc-900">
                                            2
                                        </div>
                                        <!-- Avatar -->
                                        <div class="w-24 h-24 md:w-28 md:h-28 rounded-full border-4 border-gray-400/60 overflow-hidden bg-gradient-to-b from-gray-600 to-gray-800 shadow-xl shadow-gray-500/10">
                                            @if (top3[1]?.urlFotoPerfil) {
                                                <img [src]="top3[1].urlFotoPerfil" alt="{{ top3[1].nome }}" class="w-full h-full object-cover">
                                            } @else {
                                                <div class="w-full h-full flex items-center justify-center bg-gray-700">
                                                    <mat-icon svgIcon="heroicons_solid:user" class="text-gray-400 icon-size-10"></mat-icon>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="text-center mt-2">
                                        <div class="font-bold text-white text-sm md:text-base max-w-[100px] md:max-w-[130px] truncate">{{ top3[1]?.nome?.split(' ').slice(0, 2).join(' ') }}</div>
                                        <div class="text-gray-300 font-black text-xl md:text-2xl mt-1">{{ top3[1]?.pontuacao | number:'1.0-0' }}</div>
                                        <span class="inline-block bg-gray-500/20 text-gray-300 text-xs font-medium px-2 py-0.5 rounded-full mt-1">pontos</span>
                                    </div>
                                </div>
                            }

                            <!-- 1º Lugar -->
                            <div class="flex flex-col items-center -mt-10 transform hover:scale-105 transition-transform duration-300">
                                <div class="relative mb-3">
                                    <!-- Coroa animada - acima do avatar -->
                                    <div class="absolute -top-10 left-1/2 -translate-x-1/2 z-20">
                                        <mat-icon class="material-symbols-outlined text-amber-400 text-4xl drop-shadow-[0_2px_8px_rgba(251,191,36,0.6)]" style="animation: float 2s ease-in-out infinite;">crown</mat-icon>
                                    </div>
                                    <!-- Badge de posição -->
                                    <div class="absolute -top-2 left-1/2 -translate-x-1/2 z-10 w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-600 rounded-full flex items-center justify-center font-black text-2xl text-white shadow-xl shadow-amber-500/40 ring-4 ring-zinc-900">
                                        1
                                    </div>
                                    <!-- Avatar -->
                                    <div class="w-32 h-32 md:w-40 md:h-40 rounded-full border-4 border-amber-500 overflow-hidden bg-gradient-to-b from-amber-500/40 to-orange-600/40 shadow-2xl shadow-amber-500/30">
                                        @if (top3[0]?.urlFotoPerfil) {
                                            <img [src]="top3[0].urlFotoPerfil" alt="{{ top3[0].nome }}" class="w-full h-full object-cover">
                                        } @else {
                                            <div class="w-full h-full flex items-center justify-center bg-amber-900/50">
                                                <mat-icon svgIcon="heroicons_solid:user" class="text-amber-400 icon-size-14"></mat-icon>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div class="text-center mt-3">
                                    <div class="font-black text-white text-base md:text-xl max-w-[130px] md:max-w-[160px] truncate">{{ top3[0]?.nome?.split(' ').slice(0, 2).join(' ') }}</div>
                                    <div class="text-amber-400 font-black text-3xl md:text-4xl mt-1 drop-shadow-lg">{{ top3[0]?.pontuacao | number:'1.0-0' }}</div>
                                    <span class="inline-block bg-amber-500/20 text-amber-400 text-xs font-semibold px-3 py-1 rounded-full mt-1">🏆 Líder</span>
                                </div>
                            </div>

                            <!-- 3º Lugar -->
                            @if (top3.length >= 3) {
                                <div class="flex flex-col items-center transform hover:scale-105 transition-transform duration-300">
                                    <div class="relative mb-3">
                                        <!-- Badge de posição -->
                                        <div class="absolute -top-3 left-1/2 -translate-x-1/2 z-10 w-8 h-8 bg-gradient-to-br from-amber-600 to-amber-800 rounded-full flex items-center justify-center font-black text-lg text-white shadow-lg ring-4 ring-zinc-900">
                                            3
                                        </div>
                                        <!-- Avatar -->
                                        <div class="w-24 h-24 md:w-28 md:h-28 rounded-full border-4 border-amber-700/60 overflow-hidden bg-gradient-to-b from-amber-800 to-amber-950 shadow-xl shadow-amber-700/10">
                                            @if (top3[2]?.urlFotoPerfil) {
                                                <img [src]="top3[2].urlFotoPerfil" alt="{{ top3[2].nome }}" class="w-full h-full object-cover">
                                            } @else {
                                                <div class="w-full h-full flex items-center justify-center bg-amber-900">
                                                    <mat-icon svgIcon="heroicons_solid:user" class="text-amber-600 icon-size-10"></mat-icon>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="text-center mt-2">
                                        <div class="font-bold text-white text-sm md:text-base max-w-[100px] md:max-w-[130px] truncate">{{ top3[2]?.nome?.split(' ').slice(0, 2).join(' ') }}</div>
                                        <div class="text-amber-600 font-black text-xl md:text-2xl mt-1">{{ top3[2]?.pontuacao | number:'1.0-0' }}</div>
                                        <span class="inline-block bg-amber-700/20 text-amber-600 text-xs font-medium px-2 py-0.5 rounded-full mt-1">pontos</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </section>
                }

                <!-- Lista Completa -->
                <section class="bg-zinc-900/80 rounded-2xl border border-zinc-800 overflow-hidden">
                    <!-- Header da seção -->
                    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-6 border-b border-zinc-800 bg-zinc-900">
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 bg-amber-500/10 rounded-xl flex items-center justify-center">
                                <mat-icon svgIcon="heroicons_outline:list-bullet" class="text-amber-500 icon-size-5"></mat-icon>
                            </div>
                            <div>
                                <h2 class="text-lg font-bold text-white">Classificação Completa</h2>
                                <p class="text-white/50 text-sm">{{ totalRegistros() }} colaboradores no ranking</p>
                            </div>
                        </div>
                    </div>

                    <!-- Lista -->
                    <div class="divide-y divide-zinc-800/50">
                        @for (item of classificacao; track trackByUser($index, item)) {
                            <div class="px-4 md:px-6 py-4 transition-all duration-200 group"
                                 [ngClass]="item.isCurrentUser 
                                    ? 'bg-gradient-to-r from-amber-500/15 to-transparent' 
                                    : 'hover:bg-zinc-800/50'">
                                <div class="flex items-center justify-between gap-4">
                                    <div class="flex items-center gap-3 md:gap-5 flex-1 min-w-0">
                                        <!-- Posição -->
                                        <div class="flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center font-black text-lg transition-transform duration-200 group-hover:scale-110"
                                             [ngClass]="getPositionClasses(item.posicao)">
                                            {{ item.posicao }}
                                        </div>

                                        <!-- Foto -->
                                        <div class="flex-shrink-0 relative">
                                            @if (item.urlFotoPerfil) {
                                                <img [src]="item.urlFotoPerfil" 
                                                     alt="{{ item.nome }}" 
                                                     class="w-14 h-14 rounded-full object-cover ring-2 ring-offset-2 ring-offset-zinc-900 transition-all duration-200 group-hover:ring-amber-500/50"
                                                     [ngClass]="item.isCurrentUser ? 'ring-amber-500' : 'ring-zinc-700'">
                                            } @else {
                                                <div class="w-14 h-14 rounded-full flex items-center justify-center ring-2 ring-offset-2 ring-offset-zinc-900 transition-all duration-200 group-hover:ring-amber-500/50"
                                                     [ngClass]="item.isCurrentUser 
                                                        ? 'bg-amber-500/20 ring-amber-500' 
                                                        : 'bg-zinc-800 ring-zinc-700'">
                                                    <mat-icon svgIcon="heroicons_solid:user" 
                                                              class="icon-size-7"
                                                              [ngClass]="item.isCurrentUser ? 'text-amber-500' : 'text-white/30'"></mat-icon>
                                                </div>
                                            }
                                            @if (item.isCurrentUser) {
                                                <div class="absolute -bottom-1 -right-1 bg-amber-500 text-zinc-900 text-[9px] font-black px-1.5 py-0.5 rounded-full shadow-lg">VOCÊ</div>
                                            }
                                        </div>

                                        <!-- Nome e badge -->
                                        <div class="flex-1 min-w-0">
                                            <div class="font-semibold text-base md:text-lg truncate transition-colors duration-200"
                                                 [ngClass]="item.isCurrentUser ? 'text-amber-400' : 'text-white group-hover:text-amber-400'">
                                                {{ item.nome }}
                                            </div>
                                            @if (item.posicao <= 3) {
                                                <span class="text-xs font-medium flex items-center gap-1 mt-0.5"
                                                      [ngClass]="{
                                                          'text-amber-400': item.posicao === 1,
                                                          'text-gray-400': item.posicao === 2,
                                                          'text-amber-600': item.posicao === 3
                                                      }">
                                                    @if (item.posicao === 1) {
                                                        <span>🏆</span> Líder
                                                    } @else if (item.posicao === 2) {
                                                        <span>🥈</span> Vice-líder
                                                    } @else if (item.posicao === 3) {
                                                        <span>🥉</span> 3º colocado
                                                    }
                                                </span>
                                            }
                                        </div>
                                    </div>

                                    <!-- Pontuação -->
                                    <div class="flex-shrink-0 text-right">
                                        <div class="font-black text-2xl md:text-3xl transition-colors duration-200"
                                             [ngClass]="(item.isCurrentUser || item.posicao <= 3) ? 'text-amber-400' : 'text-white group-hover:text-amber-400'">
                                            {{ item.pontuacao | number:'1.0-0' }}
                                        </div>
                                        <div class="text-white/40 text-xs font-medium">pontos</div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <!-- Paginação -->
                    @if (showPagination()) {
                        <div class="flex flex-col sm:flex-row items-center justify-between gap-4 p-6 border-t border-zinc-800 bg-zinc-900/50">
                            <div class="text-sm text-white/50 font-medium">
                                Página <span class="text-white">{{ page() }}</span> de <span class="text-white">{{ totalPages() }}</span>
                            </div>
                            <div class="flex gap-3">
                                <button class="flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
                                        [ngClass]="hasPrev() 
                                            ? 'bg-zinc-800 text-white hover:bg-amber-500 hover:text-zinc-900 border border-zinc-700 hover:border-amber-500' 
                                            : 'bg-zinc-800/50 text-white/50 border border-zinc-800'"
                                        (click)="irAnterior()" 
                                        [disabled]="!hasPrev()">
                                    <mat-icon svgIcon="heroicons_outline:chevron-left" class="icon-size-5"></mat-icon>
                                    Anterior
                                </button>
                                <button class="flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
                                        [ngClass]="hasNext() 
                                            ? 'bg-zinc-800 text-white hover:bg-amber-500 hover:text-zinc-900 border border-zinc-700 hover:border-amber-500' 
                                            : 'bg-zinc-800/50 text-white/50 border border-zinc-800'"
                                        (click)="irProxima()" 
                                        [disabled]="!hasNext()">
                                    Próxima
                                    <mat-icon svgIcon="heroicons_outline:chevron-right" class="icon-size-5"></mat-icon>
                                </button>
                            </div>
                        </div>
                    }
                </section>
            }
        }
    </div>
</div>
